import { render } from "./GerminacaoFormView.vue?vue&type=template&id=2ede1834"
import script from "./GerminacaoFormView.vue?vue&type=script&lang=js"
export * from "./GerminacaoFormView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__